// src/components/icons/KycIcon.jsx
import React from "react";

const KycIcon = ({
  width = "1em",
  height = "1em",
  stroke = "currentColor",
  className = ""
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.5002 1.66666H5.00016C4.55814 1.66666 4.13421 1.84225 3.82165 2.15481C3.50909 2.46737 3.3335 2.8913 3.3335 3.33332V16.6667C3.3335 17.1087 3.50909 17.5326 3.82165 17.8452C4.13421 18.1577 4.55814 18.3333 5.00016 18.3333H15.0002C15.4422 18.3333 15.8661 18.1577 16.1787 17.8452C16.4912 17.5326 16.6668 17.1087 16.6668 16.6667V5.83332L12.5002 1.66666Z"
        stroke={stroke}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6665 1.66666V4.99999C11.6665 5.44202 11.8421 5.86594 12.1547 6.1785C12.4672 6.49106 12.8911 6.66666 13.3332 6.66666H16.6665"
        stroke={stroke}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 12.5L9.16667 14.1667L12.5 10.8333"
        stroke={stroke}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default KycIcon;
